import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ type, className, onClick, children, disabled }) => {
	return (
		<button type={type} className={className} onClick={onClick} disabled={disabled}>
			{children}
		</button>
	);
};

Button.propTypes = {
	type: PropTypes.string.isRequired,
	className: PropTypes.string.isRequired,
	onClick: PropTypes.func
};

export default Button;
